var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 5,
    viewBox: "0 0 7 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80358 1.04518C6.67916 0.921506 6.51086 0.852087 6.33543 0.852087C6.16 0.852087 5.9917 0.921506 5.86729 1.04518L3.4834 3.39587L6.33543 0.852087C6.21102 0.72841 0.839995 0.852087 0.664566 0.852087C0.489137 0.852087 0.320836 0.921506 0.196421 1.04518C0.134182 1.10691 0.084781 1.18036 0.0510688 1.26128C0.0173566 1.3422 0 1.42899 0 1.51665C0 1.60431 0.0173566 1.6911 0.0510688 1.77202C0.084781 1.85294 0.134182 1.92638 0.196421 1.98811L3.01193 4.80363C3.07366 4.86587 3.14711 4.91527 3.22803 4.94898C3.30894 4.98269 3.39574 5.00005 3.4834 5.00005C3.57106 5.00005 3.65785 4.98269 3.73877 4.94898C3.81969 4.91527 3.89313 4.86587 3.95486 4.80363L6.80358 1.98811C6.86582 1.92638 6.91522 1.85294 6.94893 1.77202C6.98264 1.6911 7 1.60431 7 1.51665C7 1.42899 6.98264 1.3422 6.94893 1.26128C6.91522 1.18036 6.86582 1.10691 6.80358 1.04518Z",
    fill: "#657795"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown);
export default __webpack_public_path__ + "static/media/angle-down.3499e12fe6b73df2f94421764cea1dfb.svg";
export { ForwardRef as ReactComponent };